import React from "react";
import { COLORS } from "../constants";
import styles from "./maintenance.module.scss";

function Error404Page() {
    return (
        <div
            style={{
                backgroundColor: COLORS.lightGray,
                color: "black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "100vh",
                fontFamily: "arial",
                textAlign: "center",
            }}
        >
            <div className={styles["center-box"]}>
                <h1>
                    <b>Scheduled Maintenance</b>
                </h1>
                The return app is currently undergoing maintenance.
                <br />
                It's expected to be up and running within an hour.
            </div>
        </div>
    );
}

export default Error404Page;
